import { render } from "./MmodelsCreate.vue?vue&type=template&id=6f2793d0&scoped=true"
import script from "./MmodelsCreate.vue?vue&type=script&lang=js"
export * from "./MmodelsCreate.vue?vue&type=script&lang=js"

import "./MmodelsCreate.vue?vue&type=style&index=0&id=6f2793d0&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2793d0"]])

export default __exports__